// extracted by mini-css-extract-plugin
export default {"wrapper":"docs-table_wrapper__X-wgZ","table":"docs-table_table__ARZA0","boxName":"docs-table_boxName__jgBTt","boxStatus":"docs-table_boxStatus__y4Vx9"};